import React, { useRef, useState } from "react";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import Styles from "../../Shared/sharedStyles.module.scss";
import InputField from "../../Shared/inputField/inputField";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";
import { validPhoneNumber } from "../../../../../utils/validation";
import { IdsGenerator } from "../../../../../utils/idGenerator";

function CorporateVerificationServicePopup({ handleResponse, name }: any) {
  const errorObject = {
    phoneNumberError: false,
    consentError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const phoneNumberRef = useRef<any>("");

  function isValid() {
    if (validPhoneNumber(phoneNumberRef.current.value.trim())) {
      setError(errorObject);
      return setIsDisabled(false);
    }
    setError(() => ({
      ...error,
      phoneNumberError: true,
    }));
    return setIsDisabled(true);
  }

  function handleCheck() {
    const phoneNumber = phoneNumberRef.current.value;
    const consent = isChecked === true ? "Y" : "N";

    if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    setLoading(true);
    handleResponse({ phoneNumber, consent }, setLoading);
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>
              Mobile Number
            </label>
            <InputField
              id={IdsGenerator({
                prefix: `${name} popup`,
                id: "change",
                suffix: "mobile number",
              })}
              onChange={isValid}
              maxLength={10}
              inputRef={phoneNumberRef}
              isError={error.phoneNumberError}
              purpose="forPan"
            />
            {error.phoneNumberError && (
              <ErrorMessage>Please enter a valid Phone number</ErrorMessage>
            )}
          </div>
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                id={IdsGenerator({
                  prefix: `${name} popup`,
                  id: "check",
                  suffix: "consent",
                })}
                data-testid={IdsGenerator({
                  prefix: `${name} popup`,
                  id: "check",
                  suffix: "consent",
                })}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => {
                  setIsChecked(e.target.checked);
                  isValid();
                }}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id={IdsGenerator({
                prefix: `${name} popup`,
                id: "click",
                suffix: "run verification",
              })}
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CorporateVerificationServicePopup;
